"use strict";

exports.__esModule = true;
exports.TEXT_ANCHOR_START = exports.TEXT_ANCHOR_MIDDLE = exports.TEXT_ANCHOR_END = exports.TAG_UNTAGGED = exports.REPORTING_PERIOD_WORKDAY = exports.REPORTING_PERIOD_SHIFT = exports.METRICS_PERIOD_YEAR = exports.METRICS_PERIOD_WORKDAY = exports.METRICS_PERIOD_WEEK = exports.METRICS_PERIOD_SHIFT = exports.METRICS_PERIOD_QUARTER = exports.METRICS_PERIOD_MONTH = exports.METRICS_PERIOD_HOUR = exports.METRICS_MILLISECOND = exports.METRICS_FRACTIONAL_PERCENT = exports.METRICS_COUNT = exports.CATEGORY_SAMPLE = exports.CATEGORY_EVENT = exports.CATEGORY_CONDITION = void 0;
var METRICS_PERIOD_SHIFT = exports.METRICS_PERIOD_SHIFT = "SHIFT";
var METRICS_PERIOD_WORKDAY = exports.METRICS_PERIOD_WORKDAY = "WORKDAY";
var METRICS_PERIOD_HOUR = exports.METRICS_PERIOD_HOUR = "HOUR";
var METRICS_PERIOD_WEEK = exports.METRICS_PERIOD_WEEK = "WEEK";
var METRICS_PERIOD_MONTH = exports.METRICS_PERIOD_MONTH = "MONTH";
var METRICS_PERIOD_QUARTER = exports.METRICS_PERIOD_QUARTER = "QUARTER";
var METRICS_PERIOD_YEAR = exports.METRICS_PERIOD_YEAR = "YEAR";
var METRICS_COUNT = exports.METRICS_COUNT = "COUNT";
var METRICS_MILLISECOND = exports.METRICS_MILLISECOND = "MILLISECOND";
var METRICS_FRACTIONAL_PERCENT = exports.METRICS_FRACTIONAL_PERCENT = "FRACTIONAL_PERCENT";
var TAG_UNTAGGED = exports.TAG_UNTAGGED = "Untagged";
var CATEGORY_SAMPLE = exports.CATEGORY_SAMPLE = "SAMPLE";
var CATEGORY_EVENT = exports.CATEGORY_EVENT = "EVENT";
var CATEGORY_CONDITION = exports.CATEGORY_CONDITION = "CONDITION";
var REPORTING_PERIOD_SHIFT = exports.REPORTING_PERIOD_SHIFT = "shift";
var REPORTING_PERIOD_WORKDAY = exports.REPORTING_PERIOD_WORKDAY = "workday";
var TEXT_ANCHOR_MIDDLE = exports.TEXT_ANCHOR_MIDDLE = "middle";
var TEXT_ANCHOR_START = exports.TEXT_ANCHOR_START = "start";
var TEXT_ANCHOR_END = exports.TEXT_ANCHOR_END = "end";